import Vue from 'vue'
import Router from 'vue-router'
import PublicLayout from './views/layouts/PublicLayout.vue'
import Home from './views/pages/Home.vue'
import About from './views/pages/About.vue'
import UnitList from './views/pages/UnitList.vue'
import UnitDetail from './views/pages/UnitDetail.vue'
import TermCondition from './views/pages/TermCondition.vue'
import Register from './views/pages/Register.vue'
import Dashboard from './views/pages/Dashboard.vue'
import MyAccount from './views/pages/MyAccount.vue'
import AdminLogin from './views/administrator/AdminLogin.vue'
import AdminLayout from './views/administrator/layouts-admin/AdminLayout.vue'
import AdminAbout from './views/administrator/pages-admin/AdminAbout.vue'
import AdminCustomerList from './views/administrator/pages-admin/CustomerList.vue'
import AdminUserList from './views/administrator/pages-admin/user/UserList.vue'
import AdminUserEdit from './views/administrator/pages-admin/user/UserEdit.vue'
import ExportLog from './views/administrator/pages-admin/ExportLog.vue'

Vue.use(Router);
const authGuardAgent = (to, from, next) => {
  const loggedIn = localStorage.getItem('agenthub-info');
  if (!loggedIn) {
      return next('/');
    }
    next();
}
const authGuardAadmin = (to, from, next) => {
  const loggedIn = localStorage.getItem('agenthub-admin');
  if (!loggedIn) {
      return next('/agentclound-login');
    }
    next();
}
const router = new Router({
  scrollBehavior () {
    return { x: 0, y: 0 };
  },
    mode: 'history',
    routes: [
      {
        path: '/',
        component: PublicLayout,
        children: [
          {
            path: '',
            component: Home
          },
          {
            path: 'about-us',
            component: About
          },
          {
            path: 'unit-list',
            component: UnitList
          },
          {
            path: 'unit-detail/:id',
            component: UnitDetail
          },
          {
            path: 'term-condition',
            component: TermCondition
          },
          {
            path: 'register',
            component: Register
          },
          {
            path: 'dashboard',
            component: Dashboard,
            beforeEnter: authGuardAgent
          },
          {
            path: 'my-account',
            component: MyAccount,
            beforeEnter: authGuardAgent
          }
        ]
      },
      {
        path: '/agentclound-login',
        component: AdminLogin
      },
      {
        path: '/agentclound-management',
        component: AdminLayout,
        beforeEnter: authGuardAadmin,
        redirect: '/agentclound-management/about',
        children: [
          {
            path: '/agentclound-management/about',
            component: AdminAbout
          },
          {
            path: '/agentclound-management/customer-list',
            component: AdminCustomerList
          },
          {
            path: '/agentclound-management/user-list',
            component: AdminUserList
          },
          {
            path: '/agentclound-management/user-list/edit/:id',
            component: AdminUserEdit
          },
          {
            path: '/agentclound-management/export-log',
            component: ExportLog
          }
        ]
      }
    ]
  });

  export default router